import React, { useState, useEffect } from 'react';

const MediaPoster = ({
  mediaItem,
  editMode,
  isAdmin,
  uploading,
  handleImageUpload,
}) => {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Reset image error state when mediaItem changes
    setImageError(false);
  }, [mediaItem?.vertical_image]);

  const onImageError = () => {
    console.error(`Failed to load image for ${mediaItem.type}: ${mediaItem.vertical_image}`);
    setImageError(true);
  };

  return (
    <section className="poster-section">
      {imageError || !mediaItem?.vertical_image ? (
        <div className="poster-placeholder">
          {mediaItem?.type === 'Anime' || mediaItem?.type === 'AnimeMovie' || mediaItem?.type === 'AnimeSerie'
            ? 'Anime Image Unavailable'
            : 'No Image Available'}
        </div>
      ) : (
        <img
          src={mediaItem.vertical_image}
          alt={`${mediaItem.title} poster`}
          className="poster-img"
          onError={onImageError}
        />
      )}
      {editMode && isAdmin && (
        <>
          <input
            type="file"
            id="vertical-image-upload"
            accept="image/*"
            onChange={(e) => handleImageUpload('vertical_image', e.target.files[0])}
            style={{ display: 'none' }}
          />
          <label htmlFor="vertical-image-upload" className="upload-label">
            {uploading.vert ? 'Uploading...' : 'Change Poster'}
          </label>
        </>
      )}
    </section>
  );
};

export default MediaPoster;